// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 524 ? "app" : chunkId) + "." + {"349":"36119ebf8456742b8758","448":"b5e34c54d1610264e8eb","524":"e1b64345592791fdc732"}[chunkId] + ".css";
};